import { h, render } from "preact";

/**
 * Монтирует Preact-компонент в элемент по id.
 * Если элемента нет — тихо выходит.
 */
export function mount(id, Component, props = {}) {
  const el = document.getElementById(id);
  if (!el) return null;
  render(h(Component, props), el);
  return el;
}
